import { List, Paper, Typography } from '@mui/material';
import CharacterItem from './CharacterItem';
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    paper: {
        marginBottom: theme.spacing(2)
    },
    text: {
        textAlign: 'center'
    }
}));

const CharacterItems = ({ characters }) => {
    const classes = useStyles();
    const characterNames = Object.keys(characters).sort();

    return (
        <Paper className={classes.paper}>
            {characterNames.length > 0 ? (
                <List dense>
                    {characterNames.map(characterName => {
                        const characterId = characters[characterName];

                        return (
                            <CharacterItem
                                key={characterName}
                                characterName={characterName}
                                characterId={characterId}
                            />
                        );
                    })}
                </List>
            ) : (
                <Typography className={classes.text}>
                    Fill in your character names above and hit "Start" to calculate how many total unique kills, total
                    isk destroyed and solo kills you've got across all your alts.
                </Typography>
            )}
        </Paper>
    );
};

export default CharacterItems;
